<template>
    <div class="wf-field">
        <label class="wf-label">
            {{ label }} <span v-if="isRequired" class="wf-required">*</span>
        </label>
        <p v-if="instruction" class="wf-instruction">{{ instruction }}</p>
        <div class="wf-rating">
            <button
                v-for="star in 5"
                :key="star"
                type="button"
                class="wf-rating-star"
                :class="{ 'is-active': star <= (value || 0) }"
                @click="emitValue(star)"
            >
                <i :class="star <= (value || 0) ? 'fas fa-star' : 'fal fa-star'"></i>
            </button>
        </div>
        <p v-if="help" class="wf-help">{{ help }}</p>
    </div>
</template>

<script>
import FieldMixin from './FieldMixin'

export default {
    name: 'RatingField',
    mixins: [FieldMixin]
}
</script>
